import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import UtimacoPacketSwitchList from './containers/UtimacoPacketSwitchList';
import UtimacoPacketSwitchCreate from './containers/UtimacoPacketSwitchCreate';
import UtimacoPacketSwitchEdit from './containers/UtimacoPacketSwitchEdit';
import UtimacoPacketSwitchView from './containers/UtimacoPacketSwitchView';
import { MISCELLANEOUS, SYSTEM_CONFIGURATION_ROUTE, UTIMACO_PACKET_SWITCH_ROUTE } from '../../constants';

interface Props {
}

const UtimacoPacketSwitch: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}`}>
        <UtimacoPacketSwitchList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}/create`}>
        <UtimacoPacketSwitchCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}/edit`}>
        <UtimacoPacketSwitchEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}/view`}>
        <UtimacoPacketSwitchView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default UtimacoPacketSwitch;
